"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useGoogleMap = _interopRequireDefault(require("@devsontap/dot-react-common/core/maps/useGoogleMap"));

var _selectors = require("../../../redux/locations/selectors");

require("./index.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var CONFIG = {
  fullscreenControl: false,
  streetViewControl: false,
  zoomControl: false,
  mapTypeControl: false
};
/**
 * TODO: Let's make sure this API Key is from Prod. I'm OK wit hard-coding it into the project so long as it's not from Dev
 *
 * TODO: Fix the Anchor on the circular markers
 */

var MobileGoogleMap = function MobileGoogleMap(_ref) {
  var lat = _ref.lat,
      lng = _ref.lng,
      zoom = _ref.zoom,
      currentIndex = _ref.currentIndex;
  var map = (0, _useGoogleMap.default)("AIzaSyCSvWkVdrGsFpOsrnvCLVFZWpGgtGbrVRw", lat, lng, zoom, CONFIG, "map");

  var _useFilteredLocations = (0, _selectors.useFilteredLocationsSelector)(),
      filteredLocations = _useFilteredLocations.filteredLocations,
      filteredLocationIdsString = _useFilteredLocations.filteredLocationIdsString;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      marker = _useState2[0],
      setMarker = _useState2[1];

  (0, _react.useEffect)(function () {
    if (map && filteredLocations && filteredLocations.length && currentIndex > -1 && currentIndex < filteredLocations.length) {
      var location = filteredLocations[currentIndex];
      var position = new google.maps.LatLng({
        lat: location.latitude,
        lng: location.longitude
      });
      var icon = {
        url: _getMarkerIcon(location)
      };

      if (!marker) {
        setMarker(new google.maps.Marker({
          position: position,
          map: map,
          icon: icon
        }));
      } else {
        marker.setPosition(position);
        marker.setIcon(icon);
      }

      map.setZoom(14);
      map.setCenter(position);
    }
  }, [filteredLocationIdsString, currentIndex, map]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react.default.createElement("div", {
    id: "map",
    className: "map-container"
  });
};

function _getMarkerIcon(location) {
  return location.isPreferred ? '/img/imgMapPinPreferred.svg' : '/img/img-map-pin.svg';
}

MobileGoogleMap.defaultProps = {
  lat: 39.135216,
  lng: -96.060805,
  zoom: 4
};
var _default = MobileGoogleMap;
exports.default = _default;